import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { Button, } from "reactstrap";
import { CircularProgress } from '@material-ui/core';

function Make(props) {
    const [sendingdata, setSendingdata] = React.useState('');
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [loading, setloading] = React.useState(false);
    
    // console.log(props)

    const handleClose = (event, reason) => {
        setOpen(false);
    };

    const handleSub = (event) => {
        setloading(true)
        axios.get(process.env.REACT_APP_DOMAIN + '/make'+props.label.make+'=' + props.label.user, { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                setloading(false)
                props.fetching()
                props.fetch()

            })
            .catch((error) => {
                console.log(error)
                setloading(false)
                setSendingdata('Something went wrong')
                settt('error')
                setOpen(true);
            })
    };
    return (
        <div>
            <Button outline className='pt-1 pb-1 pl-2 pr-2' color={props.label.type} onClick={handleSub} disabled={loading} >{(loading ? <div className="no-w">One sec <CircularProgress size="12px" /></div>:<div className="no-w">Make {props.label.action}</div>)}</Button>
            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
            </Snackbar>
        </div>
    );
}


export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        superValue: state.switchRoutes.superadmin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        fullname: state.tempUser,
        theme: state.theme,
        text: state.text,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Make);